module.exports = __webpack_public_path__ + "static/img/02.635eb52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/02.jpg
// module id = 3+fx
// module chunks = 2